<template>
  <WordPreview class="flex justify-center mb-4 empty:hidden" :word="word" />

  <div v-if="word.ja" class="mt-2">
    <span>{{ $t('word.ja') }}: </span>
    <b>{{ word.ja }}</b>
  </div>
  <div v-if="word.ja_kana" class="mt-2">
    <span>{{ $t('word.jaKana') }}: </span>
    <b>{{ word.ja_kana }}</b>
  </div>
  <div v-if="word.ja_romaji" class="mt-2">
    <span>{{ $t('word.jaRomaji') }}: </span>
    <b>{{ word.ja_romaji }}</b>
  </div>
  <div v-if="word.en" class="mt-2">
    <span>{{ $t('word.en') }}: </span>
    <b>{{ word.en }}</b>
  </div>
  <div v-if="word.vi" class="mt-2">
    <span>{{ $t('word.vi') }}: </span>
    <b>{{ word.vi }}</b>
  </div>
  <div v-if="word.description_admin || word.description_vi" class="mt-2">
    <div>Giải thích:</div>
    <div v-html="word.description_admin || word.description_vi.split('Ví dụ:')[0]" />
  </div>

  <h3 class="page-subtitle mt-8">Ví dụ cách sử dụng từ {{ word.ja || word.ja_kana }}</h3>
  <TextExample :examples="word.examples" :highlight="word.ja" class="mt-4" />
</template>

<script setup lang="ts">
  import WordPreview from '&/WordPreview.vue'
  import TextExample from '&/TextExample.vue'

  defineProps<{
    word: object
  }>()
</script>
